import React , { useState } from 'react'
import Fab from '@material-ui/core/Fab'
import AddIcon from '@material-ui/icons/Add'
import EditIcon from '@material-ui/icons/Edit'
import IconButton from '@material-ui/core/IconButton'
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    root: {
      '& > *': {
        margin: theme.spacing(1),
      },
    },
    extendedIcon: {
      marginRight: theme.spacing(1),
    },
    signIn :{
        position : "aboslute",
        right : "2px",
    },
    actionBar :{
        top: "5px",
        right: "10px",
        zIndex: 9999,
        position: "absolute"
    }
  }));


function MapActions(props) {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
      if(anchorEl) handleClose()
      setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
      setAnchorEl(null);
    };
  


    return (
      <div className={classes.actionBar}>
        <Fab
          aria-label="add"
          className={(classes.signIn, classes.extendedIcon)}
        >
          <AddIcon style={{ color: "red" }} onClick={handleClick} />
        </Fab>
        <Fab aria-label="edit">
          <EditIcon />
        </Fab>

        <Menu
          id="custm-basemap-id2"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuItem onClick={handleClose}>Profile</MenuItem>
          <MenuItem onClick={handleClose}>My account</MenuItem>
          <MenuItem onClick={handleClose}>Logout</MenuItem>
        </Menu>
      </div>
    );
}

export default MapActions;